import { render, staticRenderFns } from "./ItineraryStaffPickEvent.vue?vue&type=template&id=1788b999&scoped=true&"
import script from "./ItineraryStaffPickEvent.vue?vue&type=script&lang=js&"
export * from "./ItineraryStaffPickEvent.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryStaffPickEvent.vue?vue&type=style&index=0&id=1788b999&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788b999",
  null
  
)

export default component.exports